import { getCurrentCanvas } from './get-current-canvas';

export const getCanvasJson = (cardFace, propertiesToInclude?) => {
  if (propertiesToInclude) {
    return getCurrentCanvas(cardFace).toJSON(propertiesToInclude);
  } else {
    return getCurrentCanvas(cardFace).toJSON();
  }
};
